import { AnyAction, combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelectorHook } from 'react-redux';
import { Category } from 'src/types/model.types';

type MainReducerState = {
    activeModel: Category | null;
    footerEmail: string;
};

const initialState: MainReducerState = {
    activeModel: null,
    footerEmail: ''
};

export const reducer = createSlice({
    name: 'reducer',
    initialState,
    reducers: {
        setActiveModel(state, action: PayloadAction<{ model: Category }>) {
            state.activeModel = action.payload.model;
        },
        setFooterEmail(state, { payload: email }: PayloadAction<string>) {
            state.footerEmail = email;
        }
    }
});

const reducers = reducer.reducer;

export const { setActiveModel,setFooterEmail } = reducer.actions;

export const rootReducer = combineReducers({ reducers });

type RootState = ReturnType<typeof rootReducer>;

export const useCustomSelector = createSelectorHook<RootState, AnyAction>();
